<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <base-modal-comp
    tSel="forgotPasswordModal"
    tag="form"
    @submit.native.prevent
    :title="$t('auth.forgotPassword.forgotPassword')"
    :message="$t('auth.forgotPassword.emailLink')"
    :actionText="$t('common.submit')"
    @action="submit"
    :altActionText="$t('common.cancel')"
    @altAction="close"
    :waiting="isSubmitting"
    @cancelled="close">
      <template #default>
        <input-comp
          class="email-input"
          :id="forgotPasswordRefs.forgotEmail"
          :name="forgotPasswordRefs.forgotEmail"
          :ref="forgotPasswordRefs.forgotEmail"
          autocomplete="username"
          :label="$t('common.email')"
          v-model.trim="forgotPasswordForm.email"
          v-model:errorMessages="forgotPasswordForm.emailErrorMessages"
          :validationRules="[required, emailValidator]"
        ></input-comp>
      </template>
  </base-modal-comp>
</template>

<script lang="ts">
import { postForgotPasswordAsync } from '@/api/userApi';
import { isSuccess } from '@/utils/result';
import { isAbortError } from '@/utils/apiUtils';
import { infoToast, errorToast } from '@/utils/notificationUtils';
import { required, emailValidator, formValidator, IErrorMessage } from '@/val/customValidation';

export default {
  setup() {
    return {
      required,
      emailValidator,
      formValidator,
    }
  },
  name: 'forgot-password-modal',
  props: {
    initialEmail: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isSubmitting: false,
      forgotPasswordForm: {
        email: this.initialEmail,
        emailErrorMessages: [] as IErrorMessage[],
      },
      forgotPasswordRefs: {
        forgotEmail: 'forgotEmail',
      },
    };
  },
  methods: {
    close() {
        this.$emit('close');
    },
    async submit() {
      this.isSubmitting = true;

      const validationResults = this.formValidator(this, this.forgotPasswordRefs);

      if (validationResults.length > 0) {
        return;
      }

      const response = await postForgotPasswordAsync(
          this.forgotPasswordForm.email
      );

      if (isAbortError(response)) {
          this.isSubmitting = false;
          return;
      }

      if (isSuccess(response)) {
          this.$emit('close');
          infoToast(
              this.$store,
              'auth.forgotPassword.emailSent',
              'mail_small'
          );
      } else {
          this.$emit('close');
          errorToast(this.$store, 'auth.forgotPassword.error');
      }

      this.isSubmitting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header-sub-title {
    color: $gray-med-3;
    font-size: 18px;
}
</style>
